import { useCallback, useState } from 'react';
import useFetch, { ServiceParams } from '../hooks/useFetch';
import EndPoints from '../config/EndPoint';

const useNotificationPreferencesService = () => {
  const { doGet, doPut } = useFetch();
  const [fetching, setFetching] = useState<Record<string, boolean>>({});

  const setFlag = useCallback((key: string, value: boolean) => {
    setFetching((current) => ({ ...current, [key]: value }));
  }, []);

  const list = useCallback(
    () =>
      doGet({
        url: EndPoints.NOTIFICATION_PREFERENCES.LIST,
        setFetching: (value) => setFlag('list', value),
      } as ServiceParams),
    [doGet, setFlag]
  );

  const update = useCallback(
    (userId: number, preferences: Record<string, boolean>) =>
      doPut({
        url: EndPoints.NOTIFICATION_PREFERENCES.UPDATE.replace(':id', String(userId)),
        body: { preferences },
        setFetching: (value) => setFlag(`update-${userId}`, value),
      } as ServiceParams),
    [doPut, setFlag]
  );

  return { fetching, list, update };
};

export default useNotificationPreferencesService;
